<!-- 
 采用了particle.js粒子动画做背景 
 https://www.jianshu.com/p/c52b3e91c94f

  -->
<template>
  <div>
    <!-- <div class="particles-js-box">
      <div id="particles-js"></div>
    </div> -->
    <canvas
      id="canvas"
      style="position: absolute;top: 0;left: 0;z-index: -1;"
    ></canvas>
    <!-- <div class="card-main"> -->
    <div class="report-card-content">
      <el-header class="head">
        <div class="shape-bg"></div>
        <div class="title">{{ title }}</div>
      </el-header>
      <main class="team-list" v-if="teamList.length">
        <el-card class="box-card" v-for="(team, idx) in teamList" :key="idx">
          <header class="team-name">
            <span class="label">参赛队伍：</span>
            <div class="title">{{ team.teamName }}</div>
          </header>
          <div class="student-list" v-if="team.userInfos.length">
            <div
              v-for="(student, index) in team.userInfos"
              :key="index"
              class="wrap"
            >
              <div class="img-wrap">
                <img
                  :src="
                    student.userPhoto
                      ? photoBaseUrl + student.userPhoto
                      : userPhoto
                  "
                  alt=""
                />
              </div>
              <span class="student-name">{{ student.userName }}</span>
            </div>
          </div>

          <el-footer v-if="team.teamScore">
            <span class="score-btn"
              >成绩:<i>{{ team.teamScore }}</i></span
            >
            <span class="cd-btn" @click="chaneCardStatus(team.teamId)"
              >成绩详情</span
            >
          </el-footer>
        </el-card>
      </main>
      <section class="card-modoule">
        <el-dialog
          :visible.sync="dialogVisible"
          width="1000px"
          top="0vh"
          :modal="false"
        >
          <div class="cd-head">
            <div class="title-wrap">
              <div class="title">
                <span class="label"> 队伍：</span>
                <span class="team">{{ teamObj.teamName }}</span>
              </div>
              <div class="team-score" v-if="'teamId' in teamObj">
                <!-- <span class="val">{{ teamObj.teamScore }}</span> -->
                <span class="label">成绩：</span>
                <el-progress
                  type="circle"
                  :width="70"
                  :percentage="teamObj.teamScore | formatScore"
                  :stroke-width="2"
                  :format="scoreFormat"
                  :color="colors"
                ></el-progress>
                <span class="label">分</span>
              </div>
            </div>

            <div class="student-list">
              <!-- <span>队员</span> -->
              <div
                class="wrap"
                v-for="(item, index) in teamObj.userInfos"
                :key="index"
                @click="selectStudent(index)"
              >
                <div class="img-wrap">
                  <img
                    :src="
                      item.userPhoto ? photoBaseUrl + item.userPhoto : userPhoto
                    "
                    alt=""
                  />
                </div>
                <div>
                  <span>{{ item.userName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="cd-main">
            <!-- 轮播图 -->
            <el-carousel
              trigger="click"
              :initial-index="0"
              :interval="8000"
              indicator-position="outside"
              :loop="false"
              :autoplay="false"
              @change="changeCard"
            >
              <el-carousel-item
                v-for="(card, index) in teamObj.resultPhotos"
                :key="index"
              >
                <img
                  class="cd-pic"
                  :src="
                    card.resultPhoto
                      ? photoBaseUrl + card.resultPhoto
                      : cardPhoto
                  "
                />
                <!-- <h3 class="card-name">{{ card.photoName }}</h3> -->
              </el-carousel-item>
            </el-carousel>
            <div class="right-wrap">
              <div class="card-pic-info">
                <div class="pic-name" v-if="cardObj && cardObj.photoName">
                  {{ cardObj.photoName }}
                </div>
              </div>
            </div>
          </div>
          <div class="cd-footer"></div>
        </el-dialog>
      </section>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
// /* eslint-disable */
import particlesJS from 'particles.js'
import particlesConfig from './particles2.json'
import gta_particles from './bg.js'
import REPORT_CARD from '@/axios/reportCard/reportCard.js'
export default {
  data() {
    return {
      title: '天津市高职院校 —— 人工智能大赛队伍赛况',
      showCard: false,
      dialogVisible: false,
      teamList: [],
      teamId: '',
      teamObj: {},
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 },
      ],
      studentObj: {},
      cardObj: {},
      userPhoto: require('../../../public/images/profile03.png'),
      cardPhoto: require('../../../public/images/img03.png'),
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
    }
  },
  filters: {
    formatScore(score) {
      if (!score) return 0
      score = Number(score)
      return score
    },
  },
  created() {
    // this.studentObj = this.userInfos[0]
    this.getTeamList()
  },
  mounted() {
    // this.initParticle()
    gta_particles() //粒子背景动画
  },
  methods: {
    initParticle() {
      window.particlesJS('particles-js', particlesConfig)
      // particlesJS('particles-js', particlesConfig)
      document.body.style.overflow = 'hidden'
    },
    chaneCardStatus(teamId) {
      this.showCard = true
      this.dialogVisible = true
      this.getTeamInfoByTeamId(teamId)
      this.teamId = teamId
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    selectStudent(index) {
      // this.studentObj = this.userInfos[index]
    },
    changeCard(index) {
      let { teamObj } = this
      this.cardObj = teamObj.resultPhotos[index]

      this.$forceUpdate()
    },
    /**
     *  根据小组id获取小组信息 @data teamId 小组id
     */
    getTeamInfoByTeamId(teamId) {
      if (!teamId) {
        teamId = this.teamId
      }
      let data = { teamId }
      REPORT_CARD.getTeamInfoByTeamId(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.teamObj = res.data
          if (this.teamObj.resultPhotos && this.teamObj.resultPhotos.length) {
            this.cardObj = this.teamObj.resultPhotos[0]
          } else {
            this.cardObj = {}
          }
        } else if (res.returnMsg) {
          console.error('returnMsg', res.returnMsg)
        }
      })
    },
    /**
     *  获取小组基本信息 @data teamName:小组名称
     */
    getTeamList() {
      REPORT_CARD.getTeamInfo().then((res) => {
        if (res && res.returnCode == 200) {
          this.teamList = res.data
        }
      })
    },
    scoreFormat(percentage) {
      console.log('percentage', percentage)
      percentage = Number(percentage)
      return percentage
    },
  }, //end
}
</script>

<style lang="scss" scoped>
$main_bg: #061f3e;
$second_bg: rgba(4, 10, 18, 0.7);
$main_btn: rgb(0, 222, 255);
// $main_btn: #00deff;
$font_primary_color: #fff;
$font_second_color: #060e1a;

$border_main: rgba(0, 222, 255, 0.3);
.report-card-content {
  position: absolute;
  width: 100%;
  // height: 100%;
  // overflow-y: auto;
  // overflow-x:hidden;
  // background: #050d20;
  // z-index: 10;
  .head {
    width: 100;
    margin: 10px auto;
    text-align: center;
    color: #fff;
    .title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      z-index: 999;
      margin-top: 10px;
      font-size: 28px;
    }
  }
  .shape-bg {
    position: absolute;
    content: '';
    position: absolute;
    width: 560px;
    height: 0;
    border-top: 60px solid #10254b;
    border-right: 30px solid transparent;
    border-left: 30px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
  }

  .team-list {
    width: 98%;
    height: calc(100vh - 80px);
    margin: 0 auto;
    box-sizing: border-box;
    // padding: 20px;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
    @include scroll-bar(5px, 5px, $border_main, $border_main);
    .team-name {
      width: 100%;
      margin: 10 auto;
      text-align: center;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      // border-bottom: 1px solid $border_main;
      flex-shrink: 0;
      .label {
        display: block;
        flex-shrink: 0;
        width: 70px;
        font-size: 14px;
        border-left: 4px solid $main_btn;
        height: 15px;
        margin-right: 10px;
        padding-left: 3px;
        padding-top: -2px;
        line-height: 17px;
        float: left;
      }
      .title {
        // flex: 1;
        // flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }
      // border-bottom: 1px solid $main_btn;
    }
    .box-card {
      width: 23%;
      height: 250px;
      // width: 400px;
      margin: 10px 10px;
      background: url('../../../public/images/gz.png');
      background-repeat: repeat;
      // background: $second_bg;
      color: $font_primary_color;
      border: 1px solid $border_main;
      .student-list {
        width: 100%;
        height: 100%;
        min-height: 80px;
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;
        margin-top: 20px;
        overflow-x: auto;
        padding: 0 20px;
        box-sizing: border-box;
        @include scroll-bar(2px, 5px, $border_main, $border_main);
        .wrap {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 0 4px;
          .img-wrap {
            height: 44px;
            img {
              width: 44px;
              height: 44px;
              border-radius: 22px;
            }
          }
          .student-name {
            width: 100%;
            box-sizing: border-box;
            display: block;
            text-align: center;
            margin-top: 3px;
            padding: 0;
          }
        }
      }
    }
  }
  .el-footer {
    width: 100%;
    height: 100% !important;
    // padding-top: 15px;
  }
  .score-btn {
    display: block;
    width: 200px;
    height: 44px;
    background-size: 100% 100%;
    line-height: 44px;
    text-align: center;
    font-size: 18px;
    color: #00deff;
    margin: 0 auto;
  }
  .cd-btn {
    display: block;
    width: 200px;
    height: 44px;
    background: url('../../../public/images/titBg.png');
    background-size: 100% 100%;
    line-height: 44px;
    text-align: center;
    font-size: 18px;
    color: #00deff;
    margin: 0 auto;
    cursor: pointer;
    &:hover {
      color: $border_main;
    }
  }

  ::v-deep .el-dialog__wrapper {
    background: rgba(17, 97, 143, 0.6);
    .el-dialog {
      // width: 1000px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      min-height: 500px;
      margin-top: 0;
      background: $main_bg;
      border-radius: 8px;
      border: 1px solid $border_main;
      color: #fff;
      .el-dialog__header {
        padding: 10px;
        .el-dialog__title {
          color: $font_primary_color;
        }
        .el-dialog__headerbtn {
          position: absolute;
          width: 32px;
          height: 32px;
          line-height: 36px;
          top: -16px;
          right: -16px;
          padding: 0;
          background: 0 0;
          border: none;
          outline: 0;
          cursor: pointer;
          background: #00deff;
          border-radius: 16px;
          color: #0a5b80;
          &:hover i {
            transform: rotate(180deg);
          }
          i {
            color: #061f3e;
            font-size: 20px;
            font-weight: 600;
            transition: all 0.3s;
          }
        }
      }
      .el-dialog__body {
        padding: 10px 20px;
      }
    }

    .cd-head {
      width: 100%;
      color: $font_primary_color;
      // margin:0 20px 20px 0;
      .title-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0px 10px 0;
      }
      .title {
        font-size: 28px;
        text-align: center;
        .label {
          font-size: 12px;
          margin-right: 0px;
        }
        .team {
          color: $main_btn;
        }
      }
      .team-score {
        margin-left: 50px;
        display: flex;
        align-items: center;
        .val {
          font-size: 28px;
          color: $main_btn;
        }
        .label {
          // margin-right: 5px;
          margin-left: 10px;
          font-size: 12px;
        }
        .el-progress {
          .el-progress__text {
            font-size: 20px !important;
            color: $main_btn;
          }
        }
      }
      .student-list {
        width: 94%;
        display: flex;
        justify-content: start;
        flex-wrap: nowrap;
        padding: 10px 0 0 10px;
        overflow-x: auto;
        @include scroll-bar(2px, 5px, $border_main, $border_main);
        .wrap {
          width: 50px;
          text-align: center;
          margin: 0 10px;
          color: $font_primary_color;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .img-wrap {
            height: 44px;
            img {
              width: 44px;
              height: 44px;
              border-radius: 22px;
            }
          }
          .student-name {
            width: 100%;
            box-sizing: border-box;
            display: block;
            text-align: center;
            margin-top: 3px;
            padding: 0;
          }
        }
      }
    }
    .cd-main {
      width: 100%;
      min-height: 300px;
      margin: 20px 0 0 0;
      // border: 1px solid #ddd;
      padding: 10px;
      box-sizing: border-box;
      position: relative;
      display: flex;
      justify-content: start;
      .el-carousel--horizontal {
        width: 60%;
        margin-left: 20px;
        .el-carousel__arrow {
          background: $main_btn;
          font-size: 20px;
          line-height: 36px;
          padding: 0;
          color: $font_second_color;
          font-weight: 700;
        }
        .el-carousel__indicators--outside button {
          background: $font_primary_color;
          opacity: 0.8;
        }
        .is-active {
          color: $main_btn;
          .el-carousel__button {
            background: $main_btn !important;
          }
          // border: 1px solid $main_btn;
        }
      }
      .cd-pic {
        width: 100%;
        height: auto;
      }
      .card-name {
        position: absolute;
      }
      .right-wrap {
        width: 300px;
        border: 1px solid $border_main;
        margin-left: 20px;
        .card-pic-info {
          color: $font_primary_color;
          font-size: 24px;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
          text-align: center;
          box-sizing: border-box;
          overflow-y: auto;
          padding: 10px 5px;
          @include scroll-bar(2px, 5px, $border_main, $border_main);
          .pic-name {
            margin: 0 auto;
          }
        }
      }
    }
  }
}

.particles-js-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1; //这里建议层级设为-1，但-1可能会导致被其他元素遮挡
}
#particles-js {
  background-color: $main_bg;
  width: 100%;
  height: 100%;
}
</style>
